export default __webpack_public_path__ + "static/media/seedfund-need.d6a6e622.svg";